import { StepBadge as UIStepBadge } from '@amelio/ui-library';

interface StepBadgeProps {
    /** Step number to display */
    step: number;
    /** Whether the badge is active (primary color) or inactive (gray) */
    active?: boolean;
    /** Additional CSS class names */
    className?: string;
}

export const StepBadge = ({ step, active = true, className = '' }: StepBadgeProps) => (
    <UIStepBadge
        step={step}
        variant={active ? 'primary' : 'inactive'}
        className={className}
    />
);
